import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SignatureCanvas from 'react-signature-canvas';

import Utils from '../../../Services/Utils';

import InputWrapper from '../WrapperInput';
import Button from '../../Common/Button';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

import './style.scss';

class InputSignature extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      saved: false,
      inside: false
    };
    this.sigCanvas = React.createRef();
  }

  componentDidMount() {
    this.initValidate();
    const { disabled, value } = this.props;
    if (this.sigCanvas && this.sigCanvas.current) {
      if (disabled || value) {
        if (value) {
          if (value.url || value.file) {
            this.convertImgToBase64URL(value.url || value.file, this.sigCanvas.current.fromDataURL);
          }
          this.setState({
            saved: true
          });
        }
        this.sigCanvas.current.off();
      }
      else {
        this.sigCanvas.current.on();
      }
    }
  }

  componentDidUpdate(prevProps) {
    this.initValidate();
    const { value } = this.props;
    const prevValue = prevProps ? prevProps.value : undefined;
    if (!Utils.equals(value, prevValue)) {
      if (this.sigCanvas && this.sigCanvas.current && value) {
        if (value.url || value.file) {
          this.convertImgToBase64URL(value.url || value.file, this.sigCanvas.current.fromDataURL);
        }
      }
      if (!value) {
        this.clear();
      }
    }
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  convertImgToBase64URL = (url, callback) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  };

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) return 'This field is required.';
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  clear = () => {
    const { onChange } = this.props;
    if (this.sigCanvas && this.sigCanvas.current) {
      this.sigCanvas.current.clear();
      this.sigCanvas.current.on();
      if (onChange) onChange(null);
      this.setState({
        saved: false
      });
    }
  };

  sign = () => {
    this.setState({ inside: false });
    setTimeout(() => {
      const { saved, inside } = this.state;
      if (this.sigCanvas && this.sigCanvas.current && !inside) {
        if (!this.sigCanvas.current.isEmpty() && !saved) {
          this.handleChange();
        }
      }
    }, 500);
  };

  handleChange = () => {
    const {onChange, onError, error} = this.props;
    if (this.sigCanvas && this.sigCanvas.current) {
      let img_b64 = this.sigCanvas.current.toDataURL('image/png');
      Utils.urlToFile(img_b64, 'signature.png', 'image/png').then((file) => {
        if (file) {
          if (onChange) onChange(file);
          this.setState({
            saved: true
          });
          this.sigCanvas.current.off();
        }
        else {
          this.clear();
        }
        const newError = this.validate(file);
        if (onError && !Utils.equals(newError, error)) onError(newError);
      });
    }
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      disabled,
      required,
      compact,
    } = this.props;

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
    };

    const { saved } = this.state;

    return (
      <InputWrapper
        { ...WrapperProps }
      >
        <div className='WrapperSignatureCanvas Center'>
          <div
            className='WrapperSignatureCanvas_Content Inline'
            onMouseLeave={ this.sign }
            onMouseEnter={ () => this.setState({ inside:true } ) }
          >
            <SignatureCanvas
              ref={ this.sigCanvas }
              canvasProps={
                {
                  height:compact ? 90 : 150,
                  width:'auto',
                  className: classNames('InputSignature', { InputSignature_Disabled: Boolean(disabled) })
                }
              }
              backgroundColor='rgb(255,255,255)'
            />
            { !disabled &&
              <div className='WrapperSignatureCanvas_Actions Center'>
                { saved &&
                  <Button className='Button_Clear' onClick={ this.clear }>X</Button>
                }
                {/*<Button className='Button_Small Button_Delete Inline' onClick={ this.clear }>Clear</Button>*/}
                {/*<Button className={ classNames('Button_Small Inline', {*/}
                  {/*'Button_Cancel': this.state.saved*/}
                {/*}) } onClick={ this.handleChange }>Sign</Button>*/}
              </div>
            }
          </div>
        </div>

      </InputWrapper>
    );
  }
}

InputSignature.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any,
  onError: PropTypes.func,
};

export default withShallowComparison(InputSignature, ['onChange', 'onError']);